export { default as CmsList } from './CmsList';
export { default as CmsEdit } from './CmsEdit';
export { default as CmsCreate } from './CmsCreate';


// WEBPACK FOOTER //
// ./src/modules/Cms/pages/index.ts